import { gql } from '@/modes/waterSupplier/gql';

export const GAUGE_FIELDS = gql(`
  fragment GaugeFieldsWS on Gauge {
    id
    gaugeNumber
    calibrationDate
    isDefault
    perms
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
  }
`);

export const CREDENTIAL_FIELDS = gql(`
  fragment CredentialFieldsWS on Credential {
    id
    type
    issuer
    value
    city
    state
    issueDate
    expireDate
    isDefault
    perms
    created
    updated
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
  }
`);

export const ADDRESS_FIELDS = gql(`
  fragment AddressFieldsWS on Address {
    id
    street1
    street2
    city
    state
    zip
    zipExt
  }
`);

export const TESTER_PROFILE_FIELDS = gql(
  `
    fragment TesterProfileFieldsWS on VendorProfile {
      id
      type
      name
      firstName
      lastName
      phones {
        id
        subType
        value
        extension
      }
      emails {
        id
        subType
        value
      }
      contactAddressId
      contactAddress {
        ...AddressFieldsWS
      }
      billingAddressId
      billingAddress {
        ...AddressFieldsWS
      }
      backflowTester {
        gauges(where: { archived: null }) {
          ...GaugeFieldsWS
        }
      }
      credentials(where: { archived: null }) {
        ...CredentialFieldsWS
      }
      perms
    }
  `,
  [ADDRESS_FIELDS, GAUGE_FIELDS, CREDENTIAL_FIELDS]
);

export const GET_WATER_SUPPLIER_TESTER_DETAIL = gql(
  `
  query GetTesterDetailWS($where: JSON) {
    vendors(where: $where) {
      id
      accountNumber
      status
      profile {
        ...TesterProfileFieldsWS
      }
      user {
        email
      }
      notes
      vendors(where: { status: 1 }) {
        status
        id
        profile(where: { type: 1 }, required: true) {
          id
          type
          approval
          firstName
          lastName
          backflowTester(required: true) {
            gauges(where: { archived: null }) {
              ...GaugeFieldsWS
            }
          }
          credentials(where: { type: "BACKFLOW", archived: null }) {
            ...CredentialFieldsWS
          }
        }
      }
    }
  }
  `,
  [TESTER_PROFILE_FIELDS, GAUGE_FIELDS, CREDENTIAL_FIELDS]
);
